module.exports = __webpack_public_path__ + "static/media/bg-mesa.6dc12726.webp";